import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";

const inputStyle = {
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  fontSize: "14px",
  width: "100%",
  maxWidth: "100%",
};

export default function AMCBillRegister() {
  const [chooseType, setChooseType] = useState("amcBill"); // "amcBill" | "creditNote"
  const [arn, setArn] = useState("All ARNs");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [taxPaid, setTaxPaid] = useState(true);
  const [taxUnpaid, setTaxUnpaid] = useState(true);

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>AMC Bill Register</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/billing/create-client-bill">Billing</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  AMC Bill Register
                </li>
              </ol>
            </nav>
          </div>

          <div style={cardStyle}>
            {/* Choose */}
            <div className="mb-4">
              <label className="form-label mb-2 d-block" style={{ fontSize: "14px", color: "#334155" }}>Choose :</label>
              <div className="d-flex gap-4">
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input
                    type="radio"
                    name="chooseType"
                    checked={chooseType === "amcBill"}
                    onChange={() => setChooseType("amcBill")}
                    style={{ accentColor: teal, width: "18px", height: "18px" }}
                  />
                  AMC Bill
                </label>
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input
                    type="radio"
                    name="chooseType"
                    checked={chooseType === "creditNote"}
                    onChange={() => setChooseType("creditNote")}
                    style={{ accentColor: teal, width: "18px", height: "18px" }}
                  />
                  Credit Note
                </label>
              </div>
            </div>

            {/* ARN */}
            <div className="mb-4">
              <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>ARN:</label>
              <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle}>
                <option value="All ARNs">All ARNs</option>
              </select>
            </div>

            {/* Date range */}
            <div className="mb-4">
              <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Date:</label>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  style={inputStyle}
                  placeholder="DD-MM-YYYY"
                  className="flex-grow-1"
                />
                <span className="text-muted">-</span>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  style={inputStyle}
                  placeholder="DD-MM-YYYY"
                  className="flex-grow-1"
                />
              </div>
            </div>

            {/* Checkboxes */}
            <div className="mb-4">
              <div className="d-flex gap-4">
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input type="checkbox" checked={taxPaid} onChange={(e) => setTaxPaid(e.target.checked)} style={{ accentColor: teal }} />
                  Tax Paid
                </label>
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input type="checkbox" checked={taxUnpaid} onChange={(e) => setTaxUnpaid(e.target.checked)} style={{ accentColor: teal }} />
                  Tax Unpaid
                </label>
              </div>
            </div>

            {/* Show button */}
            <div className="text-center">
              <button
                type="button"
                className="border-0 rounded px-4 py-2"
                style={{ background: teal, color: "#fff", fontWeight: 600, fontSize: "14px", cursor: "pointer" }}
              >
                Show
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
